import { render, staticRenderFns } from "./basebrandList.vue?vue&type=template&id=4d544218&scoped=true"
import script from "./basebrandList.vue?vue&type=script&lang=js"
export * from "./basebrandList.vue?vue&type=script&lang=js"
import style0 from "./basebrandList.vue?vue&type=style&index=0&id=4d544218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d544218",
  null
  
)

export default component.exports